<template>
  <div style="line-height: 20px;">
    <p v-if="show.indexOf('name') > -1">
      <span v-if="row.isDel == 2" style="color: red; display: block">已注销</span>
      <span @click="userInfoDialog" style="cursor: pointer;">昵称：<span :class="from == 2?'font-style':''">{{ row.nickName }}</span></span>
      <span style="color: #409eff; margin-left: 8px">{{ row.sex == 1?'男':row.sex == 2?'女':''}}</span>
      <span v-if="row.svipState > 0" style="color: red; margin-left: 8px">SVIP</span>
      <span v-if="row.vipState > 0 && row.svipState == 0" style="color: red; margin-left: 8px">VIP</span>
    </p>
    <get-plain v-if="show.indexOf('phone') > -1 && !isDialog" title="手机：" :code="row.phone" :uid="row.uid" :type="9" :subType="0"/>
    <get-plain-dialog v-if="show.indexOf('phone') > -1 && isDialog" title="手机：" :code="row.phone" :uid="row.uid" :type="9" :subType="0"/>
    <p v-if="show.indexOf('uid') > -1">UID：{{ row.uid }}</p>
    <p v-if="show.indexOf('birth') > -1">生日：{{ row.sysBirthday }}</p>
    <p v-if="show.indexOf('city') > -1" style="display: flex; align-items: center">
      现居城市：{{ row.city }}<IpCityAbnormal :row="row" />
    </p>
  </div>
</template>

<script>
import IpCityAbnormal from "@/components/resume/ipCityAbnormal";
import GetPlain from "@/components/resume/GetPlain";
import GetPlainDialog from "@/components/resume/GetPlainDialog";
import Dialog from "@/assets/js/dialog";
import userInfoDialog from "@/components/resume/userInfoDialog";
import userListInfoDialog from "@/components/resume/userListInfoDialog";
export default {
  name: "UserInfo",
  components: { IpCityAbnormal, GetPlain, GetPlainDialog },
  props: {
    row: {
      type: Object,
      default: () => {
        return {}
      }
    },
    userId: {
      type: String,
      default: ''
    },
    showList: {
      type: String,
      default: ''
    },
    isDialog: {
      type: Boolean,
      default: false
    },
    from: {
      type: Number,
      default: 0, //1、用户列表； 2、信息审核
    }
  },
  data() {
    return {

    }
  },
  methods: {
    userInfoDialog() {
      Dialog.open({
        title: '',
        component: this.from == 1?userListInfoDialog:userInfoDialog,
        data: {
          userId: this.userId?this.userId:this.row.userId,
          width: '800px',
        },
      })
    },
  },
  computed: {
    show() {
      return this.showList.split(',')
    }
  }
}
</script>

<style scoped>
.font-style {
  font-size: 20px;
  font-weight: bold;
  color: #333333;
}
</style>
